module.exports = __webpack_public_path__ + "img/a7.f9a682f6.jpg";